<template>
  <v-container fluid class="pa-0 bbb">
    <v-flex style="height:100vh;">
      <v-parallax src="" style="height: 100%;">
        <v-layout align-center column justify-center style="height: 100%; ">
          <v-avatar :tile="tile" :size="200">
            <img src="https://lkd.neocities.org/images/LDTEST.png" height="300%">
          </v-avatar>
          <h1 class="display-2 font-weight-thin mb-3">Lucas Di Monte</h1>
          <h4 class="subheading">Product Designer & Developer - Portfolio</h4>
          <h5 class="subheading">Honros Bachelor of Interaction Design</h5>
          
        </v-layout>
        <vue-particles
        color="#00ff3f"
        :particleOpacity="0"
        :particlesNumber="10"
        shapeType="edge"
        :particleSize="2"
        linesColor="#000000"
        :linesWidth="5"
        :lineLinked="true"
        :lineOpacity="0.8"
        :linesDistance="500"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="repulse"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
      </v-parallax>
            <div>

    </div>
    </v-flex>
    <v-container grid-list-xl text-xs-center align-content-center :style="contentSpacer">
      <h1 class="sectiontitle font-weight-thin">Academic </h1>
      <v-layout row wrap>
        <v-flex v-for="i in 1" :key="`2${i}`" md6 xs12>
          <v-toolbar color="grey darken-3" dark dense>
            <v-toolbar-title>Accolades</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>info</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card hover>
            <v-card-media class="white--text" height="250px" src="https://lkd.neocities.org/images/webd.png"> </v-card-media>
            <v-expansion-panel>
              <v-expansion-panel-content v-for="(item,i) in 5" :key="i" ripple>
                <div slot="header">Project Published in web designer magazine</div>
                <v-card>
                  <v-card-text class="grey lighten-3">I designed interactive Kiosks that used computer vision and JavaScript. These kiosks were the center peice
                    of the 2018 Sheridan IXD gradshow. Webdesigner Magazine highlighted the interactivity of the kiosks in
                    issue #276.</v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card>
        </v-flex>








        <v-flex v-for="i in 1" :key="`2${i}`" md6 sm12>
          <v-toolbar color="grey darken-3" dark dense>
            <v-toolbar-title>Hackathons</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>info</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card hover>
            <v-card-media class="white--text" height="250px" src="https://cdn.betakit.com/wp-content/uploads/2016/08/Hack-the-North-1050x700.jpg">
            </v-card-media>
            <v-expansion-panel>
              <v-expansion-panel-content v-for="(item,i) in 5" :key="i" ripple>
                <div slot="header">Project Published in web designer magazine</div>
                <v-card>
                  <v-card-text class="grey lighten-3">I designed interactive Kiosks that used computer vision and JavaScript. These kiosks were the center peice
                    of the 2018 Sheridan IXD gradshow. Webdesigner Magazine highlighted the interactivity of the kiosks in
                    issue #276.</v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card>
        </v-flex>





        <v-flex v-for="i in 1" :key="`2${i}`" md6 xs12>
          <v-card color="grey lighten-2">
            <v-btn color="grey" dark small absolute bottom right fab>
              <v-icon>add</v-icon>
            </v-btn>
            <v-layout row>
              <v-flex xs9>
                <v-card-title primary-title>
                  <div>
                    <div class="headline">Certificate - Big Data anayltics</div>
                    <div>York University</div>
                    <div>(2018)</div>
                  </div>
                </v-card-title>
              </v-flex>
              <v-flex xs5>
                <v-card-media src="https://www.ryerson.ca/content/dam/lifelinesyria/Logo_York_University.svg.png" height="125px" contain></v-card-media>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-actions class="pa-3">
              CSDA1000 Introduction to Big Data
              <br> CASDA1010 Basic Methods of Data Analytics
              <br> CSDA1030 Data Organization for Analysis
              <v-spacer></v-spacer>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
            </v-card-actions>
          </v-card>

        </v-flex>
        <v-flex v-for="i in 1" :key="`2${i}`" md6 xs12>
          <v-card color="grey lighten-2" class="">
            <v-btn color="grey" dark small absolute bottom right fab>
              <v-icon>add</v-icon>
            </v-btn>
            <v-layout row>
              <v-flex xs9>
                <v-card-title primary-title>
                  <div>
                    <div class="headline">Certificate - And Creative Leadership</div>
                    <div>Sheridan College</div>
                    <div>(2019)</div>
                  </div>
                </v-card-title>
              </v-flex>
              <v-flex xs5>
                <v-card-media src="http://ourbrand.sheridancollege.ca/img/images/sher-tagline-large.png" height="125px" contain></v-card-media>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>

            <v-card-actions class="pa-3">
              CSDA1000 Introduction to Big Data
              <br> CASDA1010 Basic Methods of Data ANalytics
              <br> CSDA1030 Data Organization for Analysis
              <v-spacer></v-spacer>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
              <v-icon>star_border</v-icon>
            </v-card-actions>
          </v-card>

        </v-flex>
















        <v-flex>
          <h1 class="sectiontitle">Portfolio Projects</h1>
          <v-card hover ripple>

            <v-card-media src="https://lkd.neocities.org/images/kiosk1.jpg" height="400px">

              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>

                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>
            <v-toolbar color="blue" dark>
              <v-icon>search</v-icon>
              <v-toolbar-title>Interactive, Computer Vision Kiosks</v-toolbar-title>

              <v-btn icon>
              </v-btn>
            </v-toolbar>

          </v-card>
        </v-flex>


        <v-flex>
          <v-card hover ripple>
            <v-toolbar dense color="blue" dark>
              <v-icon>search</v-icon>
              <v-toolbar-title>CRUD application</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>

              </v-btn>
            </v-toolbar>
            <v-card-media src="http://tattek.sk/minovate/assets/images/minovate-app.jpg" height="400px">
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>

                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>
            <v-card-text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate dolorem doloribus esse expedita
              ipsum magnam necessitatibus neque, optio perferendis placeat porro quas quisquam repellat repellendus reprehenderit
              ut.
            </v-card-text>


            <v-spacer></v-spacer>
            <v-icon class="white--text">explore</v-icon>
          </v-card>
        </v-flex>




        <v-flex>
          <v-card hover ripple>
            <v-toolbar dense color="blue" dark>
              <v-icon>search</v-icon>
              <v-toolbar-title>Canon Augmented reality</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>

              </v-btn>
            </v-toolbar>
            <v-card-media src="https://lkd.neocities.org/images/kiosk1.jpg" height="400px">
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>

                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>
            <v-card-text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium amet at cupiditate dolorem doloribus esse expedita
              ipsum magnam necessitatibus neque, optio perferendis placeat porro quas quisquam repellat repellendus reprehenderit
              ut.
            </v-card-text>


            <v-spacer></v-spacer>
            <v-icon class="white--text">explore</v-icon>
          </v-card>
        </v-flex>











      </v-layout>

          </v-container>

<v-footer
    dark
    height="auto"
    style="margin-top:5%;"
   
      >
    <v-card
      flat
      tile
      class="grey lighten-5 text-xs-center"
      style="width:100vw;"
      

    >
     
      <v-card-text class="black--text" >
        &copy;2018 — <strong>Lucas Di Monte</strong>
      </v-card-text>
    </v-card>
  </v-footer>
  </v-container>




  
</template>

<script>
  export default {
    data() {
      return {
        items: [{
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]
      }
    },
    mounted() {
      console.log(this.$vuetify.breakpoint);
    },
    computed: {
      contentSpacer() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "width: 100%;";
          case "sm":
            return "width: 100%;";
          case "md":
            return "width: 80%;";
          case "lg":
            return "width: 80%;";
          case "xl":
            return "width: 70%;";
        }
      }
    }
  };
</script>

<style>
  .bbb {
    background-image: url();
  }

  .sectiontitle {
    padding: 3%;
      }

  
</style>